import { createSelector } from "reselect";

export const getDivisionDetailsState = (state) => state.divisions.details;

export const getDivisionDetails = createSelector(getDivisionDetailsState, (state) => state.division);
export const getIsDivisionDetailsFetching = createSelector(getDivisionDetailsState, (state) => state.isFetching);
